const { define } = omii;

import tab from "./tab";
import icon from "./icon";
import rate from "./rate";
import imageSelector from "./image-selector";
import pager from "./pager";
import tree, { treeNode } from "./tree";
import loading from "./loading";
import css from "./css";

define("oi-rate", rate);
define("oi-tab", tab);
define("oi-icon", icon);
define("oi-image-selector", imageSelector);
define("oi-pager", pager);
define("oi-tree", tree);
define("oi-loading", loading);
export { css, icon, tab, rate, pager, tree, treeNode, loading };
